import React from "react";
import { EditionsFloatingBadge } from "./EditionsFloatingBadge";
import { LARIS_EDITIONS } from "./EditionsData";

function LatestBlogs() {
  return (
    <div>
      <section className="our-blog-section ptb-100 gray-light-bg editions-tailored-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-10 mb-4" style={{ textAlign: "center" }}>
              <h2 className="web mb-3">Tailored Pathology Lab Solutions</h2>
              <p>Explore LARIS software's three editions, each designed to meet the unique needs of pathology labs. From essential to advanced features, find the right edition to enhance your lab's efficiency, streamline operations, and optimize pathology management.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <EditionsFloatingBadge editions={LARIS_EDITIONS} showImages={true} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LatestBlogs;
